import { NetDebtValues, NetDebtResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculateNetDebt(values: NetDebtValues, t?: ToolsTranslations['netDebt']): NetDebtResult {
  const { interestBearingDebt, interestBearingCash } = values;

  if (interestBearingDebt < 0) {
    return { netDebt: null, isValid: false, message: t?.invalid.interestBearingDebt || 'Debt must be 0 or more' };
  }
  if (interestBearingCash < 0) {
    return { netDebt: null, isValid: false, message: t?.invalid.interestBearingCash || 'Cash must be 0 or more' };
  }

  const netDebt = Math.round((interestBearingDebt - interestBearingCash));
  if (!isFinite(netDebt)) {
    return { netDebt: null, isValid: false, message: t?.invalid.generic || 'Invalid values' };
  }

  return { netDebt, isValid: true };
}


